module.exports = __webpack_public_path__ + "static/media/top-search-active-light-icon.8ee8cced.svg";